import { Link as LinkS } from 'react-scroll';
import { Link as LinkR } from 'react-router-dom';
import styled from 'styled-components';

export const Nav = styled.nav`
  background: ${({ scrollNav }) =>
    scrollNav ? 'rgba(255, 255, 255, 0.9)' : '#ffffff'};
  backdrop-filter: saturate(180%) blur(10px);
  -webkit-backdrop-filter: saturate(180%) blur(10px);
  box-shadow: ${({ scrollNav }) =>
    scrollNav
      ? '0 6px 24px rgba(31, 45, 61, 0.12)'
      : '0 1px 0 rgba(31, 45, 61, 0.07)'};
  height: 64px;
  margin-top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  position: sticky;
  top: 0;
  z-index: 8;
  transition: box-shadow 0.3s ease, background 0.3s ease;

  /* full bar for desktop */
  @media screen and (min-width: 900px) {
    height: 80px;
  }
`;

export const NavbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  height: 100%;
  z-index: 1;
  width: 100%;
  padding: 0 20px;
  max-width: 1100px;
`;

export const NavLogo = styled(LinkR)`
  justify-self: flex-start;
  cursor: pointer;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  min-width: 0;
  font-weight: 800;
  text-decoration: none;

  /* gradient wordmark — overrides the global .app-title orange */
  & .app-title {
    font-weight: 800;
    font-size: clamp(1.05rem, 4vw, 1.5rem);
    white-space: nowrap;
    background: linear-gradient(90deg, #01bf71, #ff9a3c);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
  }
`;

/* right-side action cluster, visible at every width */
export const NavActions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 0 0 auto;
`;

export const MobileIcon = styled.button`
  display: grid;
  place-items: center;
  width: 42px;
  height: 42px;
  border: none;
  border-radius: 12px;
  background: rgba(1, 191, 113, 0.1);
  font-size: 1.3rem;
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: rgba(1, 191, 113, 0.18);
  }

  @media screen and (min-width: 900px) {
    display: none;
  }
`;

/* cart icon + count badge — hidden on mobile since it's in the BottomNav */
export const CartLink = styled(LinkR)`
  display: none;

  @media screen and (min-width: 900px) {
    position: relative;
    display: grid;
    place-items: center;
    width: 42px;
    height: 42px;
    border-radius: 12px;
    background: rgba(1, 191, 113, 0.1);
    font-size: 1.2rem;
    text-decoration: none;
    transition: background 0.15s ease;

    &:hover {
      background: rgba(1, 191, 113, 0.18);
    }
  }
`;

export const CartCount = styled.span`
  position: absolute;
  top: -5px;
  right: -5px;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  border-radius: 999px;
  background: #ff9a3c;
  color: #fff;
  font-size: 0.68rem;
  font-weight: 800;
  display: grid;
  place-items: center;
`;

export const NavMenu = styled.ul`
  display: none;

  @media screen and (min-width: 900px) {
    display: flex;
    align-items: center;
    list-style: none;
    text-align: center;
    margin: 0;
    padding: 0;
  }
`;

export const NavItem = styled.li`
  height: 80px;
`;

export const NavBtn = styled.nav`
  display: none;

  @media screen and (min-width: 900px) {
    display: flex;
    align-items: center;
  }
`;

export const NavLinks = styled(LinkS)`
  color: #1f2d3d;
  font-weight: 600;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 1rem;
  height: 100%;
  cursor: pointer;
  transition: color 0.15s ease;

  &:hover {
    color: #01bf71;
  }

  &.active {
    color: #01bf71;
    border-bottom: 3px solid #01bf71;
  }
`;

export const NavLinktest = styled(LinkR)`
  color: #1f2d3d;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
  text-decoration: none;
  padding: 0 0.65rem;
  font-size: 0.95rem;
  height: 100%;
  cursor: pointer;
  transition: color 0.15s ease;

  /* full desktop padding */
  @media screen and (min-width: 1100px) {
    padding: 0 1rem;
    font-size: 1rem;
  }

  &:hover {
    color: #01bf71;
  }

  &.active {
    color: #01bf71;
    border-bottom: 3px solid #01bf71;
  }
`;

export const NavBtnLink = styled(LinkR)`
  border-radius: 50px;
  background: #01bf71;
  white-space: nowrap;
  padding: 10px 24px;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  outline: none;
  border: none;
  cursor: pointer;
  box-shadow: 0 6px 16px rgba(1, 191, 113, 0.3);
  transition: all 0.2s ease-in-out;
  text-decoration: none;

  &:hover {
    background: #04a763;
    color: #fff;
    transform: translateY(-1px);
    box-shadow: 0 8px 20px rgba(1, 191, 113, 0.4);
  }
`;
